module.exports = __webpack_public_path__ + "img/header-diamondJewelry025Carat@2x.83600ec.webp";